// @flow

import styled from 'styled-components';
import type { Theme } from '../../../../types';

const LabelText = styled<any, Theme>('div')`
  a {
    text-decoration: none;

    &,
    &:hover,
    &:active,
    &:visited {
      color: ${props => props.theme.link.color};
    }

    &:hover {
      text-decoration: underline;
    }
  }
`;

export {
  LabelText,
};

export default null;
